import DesCatalogSearchBoxViewModel from 'viewmodel/DesCatalogSearchBoxViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';
import { registerDynImportEntry } from 'js/moduleLoader';

registerDynImportEntry(`image/cmdSearch16.svg`, () => import(`image/cmdSearch16.svg`));
registerDynImportEntry(`image/cmdClearText24.svg`, () => import(`image/cmdClearText24.svg`));
export default class DesCatalogSearchBox extends DesBaseCatalogAcc {
    constructor() {
        super(DesCatalogSearchBoxViewModel);
    }

    get provider() {
        return this.getAttribute('provider');
    }

    get locale() {
        return this.getAttribute('locale') || 'en_US';
    }

    get contentPath() {
        return this.getAttribute('content-path');
    }

    getProps() {
        return {
            provider: this.provider,
            contentpath: this.contentPath
        };
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'provider', 'locale', 'content-path'];
    }
}

if (!window.customElements.get('des-catalog-search-box')) {
    window.customElements.define('des-catalog-search-box', DesCatalogSearchBox);
}
